<script>
  import { createEventDispatcher } from 'svelte';
  import { fly } from 'svelte/transition';
  import FormDropdown from '../components/FormDropdown.svelte';
  import ScaleOption from '../components/ScaleOption.svelte';

  import axios from 'axios';

  import { formData } from '../stores/formDataStore';

  import { requiredString, validateInt } from '../utils/validation';
  import { prepareForSubmission } from '../utils/formHelpers';

  export let visible;

  const dispatch = createEventDispatcher();

  const portalOpts = ['Yes', 'No'];

  let error = false;

  let data = {
    clientPortalUse: { value: '', error: false, validation: requiredString },
    websiteNav: { value: '', error: false, validation: validateInt },
    findAllInfo: { value: '', error: false, validation: requiredString },
  };

  let webAnythingElse = '';

  const submitFeedback = async () => {
    const url = `${window.origin}/api/v1/feedback`;
    const submissionData = prepareForSubmission($formData);
    const headers = {
      headers: { 'Content-Type': 'application/json' },
    };

    try {
      const res = await axios.post(url, submissionData, headers);
      const status = await res.status;
      const feedbackSuccess = status === 200 ? true : false;
      formData.reset();
      dispatch('changePage', { page: 'finish', feedbackSuccess });
    } catch (e) {
      formData.reset();
      dispatch('changePage', { page: 'finish', feedbackSuccess: false });
    }
  };

  const handleClick = () => {
    error = false;
    Object.keys(data).forEach((key) => {
      const keyData = data[key];
      const valid = keyData.validation(keyData.value);
      if (valid) {
        data = { ...data, [key]: { ...keyData, error: false } };
      } else {
        error = true;
        data = { ...data, [key]: { ...keyData, error: true } };
      }
    });
    if (!error) {
      const newData = {
        clientPortalUse: data.clientPortalUse.value,
        websiteNav: data.websiteNav.value,
        findAllInfo: data.findAllInfo.value,
        webAnythingElse,
      };
      formData.updateFormData(newData);
      submitFeedback();
    }
  };
</script>

{#if visible}
  <div
    class="feedback-page-4 feedback-el"
    in:fly={{ x: 600, duration: 600 }}
    out:fly={{ x: -600, duration: 600 }}
  >
    <h1 class="main-heading mb-default">Finish</h1>
    <FormDropdown
      options={portalOpts}
      placeholder={'If you are a client of CES Environmental Instruments do you use the Client Portal to view your reports and documents?'}
      error={data.clientPortalUse.error}
      bind:chosenOpt={data.clientPortalUse.value}
    />
    <ScaleOption
      name="navigation"
      question="How easy was the website to navigate?"
      lowerVal="Hard"
      higherVal="Easy"
      error={data.websiteNav.error}
      bind:checked={data.websiteNav.value}
    />
    <ScaleOption
      name="find-all-info"
      question="Did you find the information you were looking for?"
      lowerVal="Disagree"
      higherVal="Agree"
      error={data.findAllInfo.error}
      bind:checked={data.findAllInfo.value}
    />
    <label class="form-label" for="web-improvments"
      >Is there anything we can do to improve the website?</label
    >
    <textarea
      name="web-improvments"
      id="web-improvments"
      class="form-input"
      placeholder={'Is there anything we can do to improve the website?'}
      bind:value={webAnythingElse}
    />
    <button class="btn base bold block centered" on:click={handleClick}
      >Complete Survey</button
    >
  </div>
{/if}
